import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section-container" }
const _hoisted_2 = { class: "section" }


import {useRouter} from 'vue-router';
import SuccessOrErrorComponent from "@/components/common/SuccessOrErrorComponent/SuccessOrErrorComponent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateListingSuccessComponent',
  props: {
    message: {},
    id: {}
  },
  setup(__props: any) {

const router = useRouter();

const props = __props;

const goToHome = () => {
  router.push({name: 'home'});
};

const goToListing = () => {
  router.push({name: 'listing', params: {id: props.id}});
}

const message = (props.id) ? "¡EL ANUNCIO HA SIDO CREADO CORRECTAMENTE!" : props.message;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SuccessOrErrorComponent, {
        status: (props.id != null) ? 'ok'  : 'error',
        text: _unref(message),
        primaryButtonText: "VOLVER AL INICIO",
        secondaryButtonText: (props.id != null) ? 'VER EL ANUNCIO' : '',
        onPrimaryClick: goToHome,
        onSecondaryClick: goToListing
      }, null, 8, ["status", "text", "secondaryButtonText"])
    ])
  ]))
}
}

})